// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sCKXY","questions":"styles_questions__1Czic","footer":"styles_footer__3bg0D"};